import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutComponent } from './pages/layout/layout.component';
import {APIService} from "./services/APIService";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthService} from "./services/AuthService";
import {CookieService} from "ngx-cookie-service";
import {RouterModule} from "@angular/router";
import { HomeComponent } from './pages/home/home.component';
import {AppRoutingModule} from "./app-routing.module";
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import {MatButtonModule} from "@angular/material/button";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { PlayerViewComponent } from './pages/player-view/player-view.component';
import { StaffActivityComponent } from './pages/staff-activity/staff-activity.component';
import { PlayerSearchComponent } from './components/player-search/player-search.component';
import {MatTableModule} from "@angular/material/table";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatInputModule} from "@angular/material/input";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatTabsModule} from "@angular/material/tabs";
import {MatChipsModule} from "@angular/material/chips";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { RankDialogueComponent } from './pages/player-view/rank-dialogue/rank-dialogue.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatStepperModule} from "@angular/material/stepper";
import {MatSelectModule} from "@angular/material/select";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import { BoothListComponent } from './pages/booth-list/booth-list.component';
import { BoothViewComponent } from './pages/booth-view/booth-view.component';
import { EditDialogueComponent } from './pages/booth-view/edit-dialogue/edit-dialogue.component';
import {ScheduleModule} from "@syncfusion/ej2-angular-schedule";
import { PlayerCreateComponent } from './pages/player-create/player-create.component';
import { AnnouncesListComponent } from './pages/announces-list/announces-list.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import {MatGridListModule} from "@angular/material/grid-list";
import {ServersComponent} from "./pages/servers/servers.component";
import {PunishmentsComponent} from "./pages/punishments/punishments.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {QuashDialogueComponent} from "./pages/punishments/quash-dialogue/quash-dialogue.component";
import {PunishDialogueComponent} from "./pages/player-view/punish-dialogue/punish-dialogue.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {RankListComponent} from "./pages/rank-list/rank-list.component";
import {Interceptor} from "./services/Interceptor";
import { TwofactorComponent } from './pages/layout/twofactor/twofactor.component';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { ScheduleListComponent } from './pages/schedule/schedule-list/schedule-list.component';
import { ScheduleViewComponent } from './pages/schedule/schedule-view/schedule-view.component';
import { ChangeStateComponent } from './pages/booth-view/change-state/change-state.component';
import { RoleDialogueComponent } from './pages/player-view/role-dialogue/role-dialogue.component';
import { QuizListComponent } from './pages/quiz-list/quiz-list.component';
import { ResourcePacksComponent } from './pages/resource-packs/resource-packs.component';
import {BoothOwnerChangeRequestsComponent} from './pages/booth-owner-change/booth-owner-change.component';
import { CoinsDialogueComponent } from './pages/player-view/coins-dialogue/coins-dialogue.component';
import { MapImagesComponent } from './pages/map-images/map-images.component';

@NgModule({
  declarations: [
    LayoutComponent,
    HomeComponent,
    UnauthorizedComponent,
    PlayerViewComponent,
    StaffActivityComponent,
    PlayerSearchComponent,
    RankDialogueComponent,
    BoothListComponent,
    BoothViewComponent,
    EditDialogueComponent,
    PlayerCreateComponent,
    AnnouncesListComponent,
    NotFoundComponent,
    ServersComponent,
    PunishmentsComponent,
    QuashDialogueComponent,
    PunishDialogueComponent,
    RankListComponent,
    TwofactorComponent,
    ScheduleComponent,
    ScheduleListComponent,
    ScheduleViewComponent,
    ChangeStateComponent,
    RoleDialogueComponent,
    QuizListComponent,
    ResourcePacksComponent,
    BoothOwnerChangeRequestsComponent,
    CoinsDialogueComponent,
    MapImagesComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    FormsModule,
    MatTableModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTabsModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatStepperModule,
    MatSelectModule,
    MatSnackBarModule,
    MatGridListModule,
    MatCheckboxModule,
    MatTooltipModule,
  ],
  providers: [APIService, AuthService, CookieService, {
    provide: HTTP_INTERCEPTORS,
    useClass: Interceptor,
    multi: true,
  }],
  bootstrap: [LayoutComponent]
})
export class AppModule { }
